export default __webpack_public_path__ + "static/media/safeProcess.19d13379.png";